import { render, staticRenderFns } from "./AttestationList.vue?vue&type=template&id=959bc146&"
import script from "./AttestationList.vue?vue&type=script&lang=js&"
export * from "./AttestationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports